import request from '../utils/request'

/**
 * K线趋势分析
 * @param {Object} params - { startIssue, endIssue }
 */
export function trendAnalysis (params) {
  return request.post('/hnSsc2/trendAnalysis', null, {
    params
  })
}
